import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CATEGORIES, MAIN_SITE_URL } from "@/data/categories";

export default function Hero() {
  const { t } = useTranslation();
  const [category, setCategory] = useState("");

  const handleCategory = (value: string) => {
    if (!value) return;
    window.open(value, "_blank", "noopener,noreferrer");
    setCategory("");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimal%20streetwear%20fashion%20flat%20lay%20with%20sneakers%20hoodies%20t-shirts%20and%20caps%20neatly%20arranged%20on%20a%20soft%20warm%20cream%20background%2C%20bright%20airy%20natural%20lighting%2C%20soft%20pastel%20green%20and%20sage%20color%20accents%2C%20modern%20editorial%20product%20photography%2C%20gentle%20soft%20shadows%2C%20fresh%20aesthetic%2C%20high%20detail%2C%20harmonious%20balanced%20composition&width=1600&height=900&seq=usfans-hero-01&orientation=landscape"
          alt="USFans Spreadsheet fashion categories"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="w-full max-w-4xl mx-auto flex flex-col items-center text-center pt-40 pb-24 md:pt-48 md:pb-32">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-medium backdrop-blur">
            <i className="ri-sparkling-line"></i>
            {t("hero.badge")}
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl font-heading font-extrabold text-background-50 leading-tight">
            {t("hero.title")}
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
            >
              <i className="ri-link"></i>
              {t("hero.cta1")}
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-background-50 text-foreground-950 font-semibold text-base hover:bg-background-100 transition-colors whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
            >
              <i className="ri-shopping-bag-line"></i>
              {t("hero.cta2")}
            </a>
          </div>

          <p className="mt-6 text-xs md:text-sm text-background-200">
            {t("hero.trust")}
          </p>

          <div className="mt-10 w-full max-w-md">
            <label className="block text-left text-xs font-medium text-background-200 mb-2">
              {t("dropdown.label")}
            </label>
            <div className="relative">
              <select
                value={category}
                onChange={(e) => handleCategory(e.target.value)}
                className="w-full appearance-none rounded-lg bg-background-50 text-foreground-900 text-sm px-4 py-3.5 pr-10 cursor-pointer border border-background-200 focus:outline-none focus:ring-2 focus:ring-primary-400"
              >
                <option value="">{t("dropdown.placeholder")}</option>
                {CATEGORIES.map((c) => (
                  <option key={c.key} value={c.url}>
                    {t(c.key)}
                  </option>
                ))}
              </select>
              <span className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center pointer-events-none text-foreground-500">
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}